// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"600d4788","994":"9563907f"}[chunkId] + ".chunk.js";
};